const FADE_DISTANCE = 60;
class Star extends Phaser.Group {
  constructor(game, direction) {
    super(game);

    // this.size = 10 + Math.random() * 10;
    // this.costume = this.drawStar(0, 0, 5, this.size, this.size * 0.35);
    this.costume = this.game.make.image(0, 0, 'ui_various', 'burst_star');
    this.costume.anchor.set(0.5);
    this.costume.scale.set(0.4 + 0.4 * Math.random());
    const angle = direction || Math.random() * 360;
    const randomSpeed = 100 + Math.random() * 100;
    this.vx = randomSpeed * Math.cos(angle);
    this.vy = randomSpeed * Math.sin(angle);
    this.costume.angle = Math.random() * 360;

    this.addChild(this.costume);
  }

  update() {
    const step = this.game.time.elapsedMS / 1000;
    this.x += this.vx * step;
    this.y += this.vy * step;
    this.angle += 1;

    const distance = Phaser.Math.distance(0, 0, this.x, this.y);

    this.costume.scale.set(this.costume.scale.x * 1.01, this.costume.scale.y * 1.01);

    if (distance > FADE_DISTANCE && this.alpha > 0.1) {
      this.alpha += (0 - this.alpha) * 8 * step;
    } else if (distance > FADE_DISTANCE) {
      this.destroy(true);
    }
  }

  drawStar(cx, cy, spikes, outerRadius, innerRadius) {
    const graphics = this.game.make.graphics();

    let rot = (Math.PI / 2) * 3;
    let x = cx;
    let y = cy;
    const step = Math.PI / spikes;

    graphics.beginFill(0xffefa3, 1);
    graphics.moveTo(cx, cy - outerRadius);
    for (let i = 0; i < spikes; i++) {
      x = cx + Math.cos(rot) * outerRadius;
      y = cy + Math.sin(rot) * outerRadius;
      graphics.lineTo(x, y);
      rot += step;

      x = cx + Math.cos(rot) * innerRadius;
      y = cy + Math.sin(rot) * innerRadius;
      graphics.lineTo(x, y);
      rot += step;
    }
    graphics.lineTo(cx, cy - outerRadius);

    return graphics;
  }
}

export class StarBurst extends Phaser.Sprite {
  constructor(game, { x, y }) {
    super(game, x, y);

    for (let i = 0; i < 360; i += 30) {
      const star = new Star(game, i);
      this.addChild(star);
    }
  }

  update() {
    if (this.children.length === 0) {
      this.destroy();
    } else {
      for (const star of this.children) {
        star.update();
      }
    }
  }

  destroy(destroyChildren = true) {
    for (let star of this.children) {
      star.destroy(true);
      star = null;
    }
    super.destroy(destroyChildren);
  }
}
